import axios from "axios";

export const HEARTBEAT_URL = `${process.env.REACT_APP_API_URL}/heartbeat`;

export function check_heartbeat() {
  const headers = {
    "Content-Type": "application/json"
  };
  return axios.get(HEARTBEAT_URL, { headers, data: {} });
}